<template>
  <div class="field">
    <div class="w-100 p-relative" :class="[{ 'p-float-label': float }, isRTL ? 'p-input-icon-left' : 'p-input-icon-right']">
      <InputText v-bind="inputProps" :id="id" :placeholder="placeholder" @blur="v.$touch" :maxlength="maxLength"
        v-model="theModel" class="custom-input form-control" @keypress="numeric ? isNumber($event) : null"
        :class="{ 'p-invalid': v.$error }" />
      <i class="icon-f icon-recycle clear-input fs-18" v-show="clearable && theModel && theModel.length > 0"
        @click="clearinput()" />
      <label v-if="float && id && label" :for="id">{{ label }}</label>
    </div>
    <small v-if="v.$error || v.$pending.$response" class="p-error">{{ $t('registration.requiredValidationError')
    }}</small>
  </div>
</template>

<script>
import InputText from "primevue/inputtext";
import { computed } from "vue";
import useVuelidate from "@vuelidate/core";
import { useI18n } from "vue-i18n";

export default {
  components: { InputText },
  props: {
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    modelValue: String,
    scope: String,
    rules: Object,
    clearable: Boolean,
    numeric: {
      type: Boolean,
      default: false
    },
    maxLength: {
      default: 255
    },
    float: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    inputProps: {
      type: Object
    }
  },
  emits: ["update:modelValue"],
  async setup(props, { emit }) {
    const theModel = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    const { t, locale } = useI18n();
    const isRTL = locale.value == "he-IL";

    function clearinput() {
      theModel.value = "";
    }

    function isNumber(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) evt.preventDefault();
      else return true;
    }

    const v = useVuelidate(props.rules, theModel, { $scope: props.scope });

    return { theModel, v, clearinput, isRTL, isNumber };
  },
};
</script>
<style lang="scss" scoped>
.clear-input {
  position: absolute;
  top: 50%;
  transform: translate(0px, -50%);

  .ltr & {
    right: 15px;
  }

  .rtl & {
    left: 15px;
  }
}
</style>
